import { useState, useEffect } from "react";
import { debounce } from "../debounce";

const THROTTLE_TIME = 200; // in ms

function useWindowSize() {
  const isClient = typeof window === "object";

  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined,
    };
  }

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    if (!isClient) {
      return false;
    }

    const debouncedHandleResize = debounce(function handleResize() {
      setWindowSize(getSize());
    }, THROTTLE_TIME);

    window.addEventListener("resize", debouncedHandleResize);

    // Clean up the event listener
    return () => window.removeEventListener("resize", debouncedHandleResize);
  }, []);

  return windowSize;
}

export default useWindowSize;
